import axios from 'axios';

const state = {
  data: null,
  isLoaded: false
};

const getters = {
  all: state => state.data,
  isLoaded: state => state.isLoaded
};

const actions = {
  retrieve(context, permalink) {
    axios
      .get('/static/info.json')
      .then(response => {
        context.commit('info/success', response.data);
        return Promise.resolve(response);
      })
      .catch(error => {
        context.commit('info/failed', error);
        return Promise.reject(error);
      });
  }
};

const mutations = {
  'info/success'(state, object) {
    state.data = object;
    state.isLoaded = true;
  },

  'info/failed'(state, error) {
    console.log(error);
    state.isLoaded = false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/content.js